import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Icon } from '@redlink/components/atoms';

export const LogoItem = memo(({ item, selectedItem }) => {
  const { styles,colors } = useStyle();
  const isSelected = selectedItem === item;
  return (
    <View style={[styles.container, isSelected && styles.containerSelected]}>
      <Icon name={item} color={!isSelected? colors.black : colors.white} />
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    width: 60,
    height: 60,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
  },
  containerSelected: {
    backgroundColor: colors.gray22,
  },
}));
